export const getPageHeight = () => {
  return Math.max(document.body.offsetHeight, document.body.scrollHeight);
};